<template>
  <div>
    <div class="header" ref="header">
      <h2>خودآموز رادیولوژی بالینی</h2>
      <p class="lead">Clinical Radiology Companion</p>
    </div>
    <div class="breadcrumb" style="position: relative">
      <router-link :to="{ path: '/' }">Main</router-link>
      <span v-for="(subOrgan, index) in organ.split('.').slice(0, (organ.match(/,/g) || []).length - 1)" :key="subOrgan, index">
      <router-link :to="{ path: organ.split('.').slice(0, index + 1).join('.') }">{{ subOrgan }}</router-link>&nbsp;>&nbsp;</span>
      <span>{{ organ.split('.')[organ.split('.').length - 1] }}</span>
      </div>
    <span style="position: absolute; top: 140px; right: 20px">مسئول پروژه: دکتر بیتا عباسی - عضو هیئت علمی گروه رادیولوژی دانشگاه علوم پزشکی مشهد</span>
    <img ref="img" style="display: none;" :src="imagePath"/>

    <div style="text-align: center; display: flex; justify-content: center; align-items: stretch">
      <div class="guide">
        <div class="guide guide1" @click="guide1Click">
          <img ref="guide1Line" class="guideLine" style="position: absolute" v-bind:style="guide1LineStyle" />
          <img ref="guide1Image" :src="guide1Path" onerror="this.style.display='none'" onload="this.style.display=''"/>
        </div>
      </div>
      <div style="display: inline-block">
        <div style="width: 100%; position: relative">
          <canvas ref="canvas" id="mainCanvas"
                    v-bind:style="canvasStyle"
                    @mousemove="mouseMove"
                    @mousewheel="onScroll"
                    @click="onClick"
            ></canvas>
            <div class="arrow rightArrow" :style="rightArrowStyle" @click="changeFrame(1)">
              &lt;
            </div>
            <span class="arrow leftArrow" :style="leftArrowStyle" @click="changeFrame(-1)">
              &gt;
            </span>
        </div>
      </div>

      <div class="guide">
        <div class="guide guide2" @click="guide2Click">
          <img ref="guide2Line" class="guideLine" style="position: absolute" v-bind:style="guide2LineStyle" />
          <img ref="guide2Image" :src="guide2Path" onerror="this.style.display='none'" onload="this.style.display=''"/>
        </div>
      </div>
    </div>

      <div class="info" v-show="activeArea.title">
        <div class="title">{{ activeArea.title}}</div>
        <div class="description" v-html="activeArea.description"></div>
      </div>
      <div v-if="activeArea.name" class="schematic">
        <img :src="schematicImagePath" onerror="this.style.display='none'"/>
      </div>
  </div>
</template>

<script>
import Organ from './Organ'

export default {
  extends: Organ,
  name: 'viewer',
  data () {
    return {
      overPoint: null,
      mousePosition: {x: 0, y: 0},
      mode: 'highlightActiveArea', // can be 'highlightActiveArea', 'locked'
      lockedArea: {},
      pointSize: 4,
      strokeStyle: 'darkgrey',
      fillStyle: '#fff'
    }
  },
  computed: {
    rightArrowStyle () {
      return {'display': (this.totalFrames && this.frame < this.totalFrames) ? '' : 'none'}
    },
    leftArrowStyle () {
      return {'display': (this.totalFrames && this.frame > 1) ? '' : 'none'}
    }
  },
  watch: {
  },
  methods: {
    drawNodes (area) {
    },
    drawAreas () {
      if (this.mode === 'highlightActiveArea') {
        this.selectActiveAreaFromMousePosition()
      }
      for (let area of this.areaList) {
        this.drawArea(area)
      }
    },
    getAreaFillStyle (area) {
      let isSelected = area === this.activeArea
      if (isSelected) {
        if (area.hasChild) {
          return 'rgba(100, 100, 255, 0.2)'
        } else {
          if (this.mode === 'locked') {
            return 'rgba(255, 100, 100, 0.4)'
          } else {
            return 'rgba(100, 100, 255, 0.4)'
          }
        }
      } else {
        return 'rgba(255, 255, 255, 0.0)'
      }
    },
    getAreaStrokeStyle (area) {
      return null
    },
    onload () {
      let pointList = []
      for (let area of this.areaList) {
        pointList = []
        area.separatedPoints = []
        for (let p of area.points) {
          if (p.restart) {
            area.separatedPoints.push(pointList)
            pointList = []
          }
          pointList.push(p)
          area.separatedPoints.push(pointList)
        }
      }

      if (this.mode === 'locked') {
        let newActiveAreaIndex = null
        for (let areaIndex in this.areaList) {
          let area = this.areaList[areaIndex]
          if (area.name === this.lockedArea.name) {
            newActiveAreaIndex = areaIndex
          }
        }
        if (newActiveAreaIndex) {
          this.selectAreaByIndex(newActiveAreaIndex)
          this.redraw()
        } else {
          // this.mode = 'highlightActiveArea'
          console.log(`${this.lockedArea.name} was not found.`)
        }
      }
    },
    mouseMove (event) {
      this.mousePosition = this.getMousePos(event)
      if (this.mode === 'highlightActiveArea') {
        this.selectActiveAreaFromMousePosition()
      }
    },
    selectActiveAreaFromMousePosition () {
      let newActiveAreaIndex = null
      for (let areaIndex in this.areaList) {
        let area = this.areaList[areaIndex]
        for (let pointList of area.separatedPoints) {
          if (this.isInside(this.mousePosition, pointList)) {
            newActiveAreaIndex = areaIndex
          }
        }
      }
      if (this.activeAreaIndex !== newActiveAreaIndex) {
        this.selectAreaByIndex(newActiveAreaIndex)
      }
    },
    onClick () {
      if (this.activeArea.hasChild) {
        let location = this.clickLocation(this.activeArea)
        this.$router.push(location)
        this.activeAreaIndex = null
      } else {
        if (this.mode === 'locked') {
          this.mode = 'highlightActiveArea'
          this.canvasStyle.cursor = 'help'
        } else if (this.activeAreaIndex) {
          this.mode = 'locked'
          this.canvasStyle.cursor = 'default'
          this.lockedArea = this.activeArea
        }
        this.redraw()
      }
    },
    onScroll (event) {
      this.changeFrame(event.deltaY > 0 ? 1 : -1)
      event.preventDefault()
    },
    changeFrame (delta) {
      if (this.totalFrames === undefined) {
        return
      }
      let nextFrame = this.frame * 1 + delta
      if (nextFrame > this.totalFrames * 1) {
        nextFrame = this.totalFrames
      }
      if (nextFrame < 1) {
        nextFrame = 1
      }
      this.$router.replace(this.organ + '\\' + nextFrame + '\\' + this.totalFrames)
      this.activeAreaIndex = null
    },
    guide1Click () {
      if (this.data.guide1.link) {
        this.$router.push(this.data.guide1.link)
      }
    },
    guide2Click () {
      if (this.data.guide2.link) {
        this.$router.push(this.data.guide2.link)
      }
    }
  }
}
</script>
<style scoped>
#mainCanvas {
  border: 0px solid #bbb;
  border-left: none;
  position: relative;
  padding: 2px;
  width: 600px;
}

.info {
  position: absolute;
  right: 10px;
  top: 160px;
  width: 350px;
  background: white;
  color: #607D8B;
  border: 5px solid green;
  padding: 10px;
  border-radius: 10px;
}

.title {
  font-size: larger;
  font-weight: bold;
  font-family: "Times new roman", Iransans;
}

.description {
  font-family: Iransans;
  text-align: justify !important;
  padding-top: 10px;
}

.schematic {
  position: absolute;
  left: 10px;
  top: 160px;
  width: 350px
}
.schematic img {
  width: 100%;
}

.guide {
  position: relative;
  border: 0 solid #bbb;
  border-left: 0;
  padding: 1px;
  display: flex;
  align-items: flex-end;
  /*width: 200px*/
}
.guide1 {
  cursor: pointer;
}
.guide2 {
  cursor: pointer;
}
.guide img {
  /*width: 100%;*/
}

.arrow {
  position: absolute;
  background-color: #225079;
  top: 40%;
  padding: 10px;
  font-size: xx-large;
  cursor: pointer;
  opacity: 0.8;
}
.rightArrow {
  right: 2px;
  background-image: url("/static/img/arrow-left-right-hi.png") no-repeat;
}
.leftArrow {
  left: 2px;
  background-image: url("/static/img/arrow-left-right-hi.png") no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/OrganViewer.vue